import script from "./SupportUser.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportUser.vue?vue&type=script&setup=true&lang=js"

import "./SupportUser.vue?vue&type=style&index=0&id=60e32ba7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60e32ba7"]])

export default __exports__